import React, { Component } from 'react';
import { Steps } from 'antd';
import './style.less';

// const { Step } = Steps;

// const stepStatusConfig = {
//   "0": "todo",
//   "1": "doing",
//   "2": "done"
// };
class CpSteps extends Component {
  onChange = (index) => {
    if (0 === +index) {
      window.history.back();
    }
    return;
  }

  render() {
    const { current, steps = [] } = this.props;
    const items = steps.map(item => ({ title: item.name }));
    return (
      <div className="cp-steps">
        <Steps current={current} size="small" onChange={this.onChange} items={items}>
          {/* {
            steps.map((item, index) => {
              return (
                <Step
                  key={index}
                  className={['stepSize', stepStatusConfig[item.status]]}
                  title={item.name}>
                </Step>
              );
            })
          } */}
        </Steps>
      </div>
    );
  }
}

export default CpSteps;